module.exports = __webpack_public_path__ + "img/pir.b9a5b344.png";